import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Star from 'components/svg/Star';
import { Button } from 'components/core/Button';

export function StarButton({
	className,
	onClick,
	onMouseEnter,
	onMouseLeave,
	value,
}) {
	const handleMouseEnter = () => onMouseEnter(value);
	const handleClick = () => onClick(value);
	return (
		<Button
			primary={false}
			className={classnames('star-button', className)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={handleClick}
		>
			<Star value={1} />
		</Button>
	);
}

StarButton.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
	value: PropTypes.number,
};

export default StarButton;
